// kfe-music-bar.js — scrubber + time readout for the music track player.
//
// Ported from rhythmic mandarin web's `src/ui/rm-audio-bar.js`. Stateless;
// driven by `currentTimeSec` and `durationSec` props, emits `seek` events
// with `{detail: timeSec}` on user input.
//
// Separate from `<kfe-audio-bar>` because that one is wired to the global
// single-shot audio engine (`core/audio-engine.js`) used by L2B / HAAI word
// playback. The music track owns its own `<audio>` element for long-form
// pause / resume / scrub, so it needs a bar that takes props rather than
// reaching for the global player.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";

export class KFEMusicBar extends KFEComponent {
  static props = ["currentTimeSec", "durationSec"];

  static styles = `
    :host { display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0; }
    input[type=range] { flex: 1; accent-color: var(--kfe-accent); }
    .time {
      color: var(--kfe-muted);
      font-size: 0.8rem;
      min-width: 5rem;
      text-align: right;
      font-variant-numeric: tabular-nums;
    }
  `;

  render() {
    const t = Number(/** @type {any} */ (this).currentTimeSec) || 0;
    const d = Math.max(0.1, Number(/** @type {any} */ (this).durationSec) || 0);
    return html`
      <input
        type="range"
        min="0"
        max="${String(d)}"
        step="0.1"
        value="${String(t)}"
        aria-label="Seek"
        on:input=${(/** @type {Event} */ e) =>
          this.emit("seek", parseFloat(/** @type {HTMLInputElement} */ (e.target).value))}>
      <span class="time">${formatTime(t)} / ${formatTime(d)}</span>
    `;
  }
}

/** @param {number} sec */
function formatTime(sec) {
  if (!Number.isFinite(sec) || sec < 0) sec = 0;
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}
